import { configureStore } from '@reduxjs/toolkit'
import liveReportReducer from 'features/liveReport/liveReportSlice'
import scheduledReportReducer from 'features/scheduledReport/scheduledReportSlice'
import uiReducer from '../features/ui/uiSlice'
import recentRecordsReducer from '../features/home/recentRecordsSlice'
import accessibleDashboardsReducer from '../features/dashboardInfo/dashboardInfoSlice'
import dashboardReducer from '../features/dashboard/dashboardSlice'
import accessibleTopicReducer from '../features/home/topicInfoSlice'
import pageConfigReducer from '../features/config/pageConfigSlice'
import emojiReducer from '../features/emoji/emojiSlice'
import widgetReducer from '../features/widget/widgetSlice'
import insightContentReducer from '../features/insightContent/insightContentSlice'
import liveReportConfigReducer from '../features/liveReportConfig/liveReportConfigSlice'
import applicationMiddleware from '../features/middleware'
import suggestedUserListReducer from '../features/suggestedUsers/suggestedUserListSlice'
import topicAnnotationsReducer from '../features/topicAnnotations/topicAnnotationsSlice'
import visualizationReducer from '../features/visualization/visualizationSlice'

const store = configureStore({
  reducer: {
    // data
    recentRecords: recentRecordsReducer, // recent visited analysis/dashboard
    accessibleDashboards: accessibleDashboardsReducer, // all accessible dashboards
    accessibleTopics: accessibleTopicReducer, // all accessible topics
    pageConfig: pageConfigReducer, // replacement of window object
    emoji: emojiReducer, // static emoji data
    dashboard: dashboardReducer, // current dashboard data
    widget: widgetReducer, // widget related data
    insightContent: insightContentReducer,
    liveReportConfig: liveReportConfigReducer,
    suggestedUserList: suggestedUserListReducer,
    scheduledReport: scheduledReportReducer,
    topicAnnotations: topicAnnotationsReducer,
    visualization: visualizationReducer,
    // ui
    ui: uiReducer,
    liveReport: liveReportReducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(applicationMiddleware)
})
export default store

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
